// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vuex from 'vuex'
import { satisfies } from 'semver';

Vue.use(Vuex)

Vue.config.productionTip = false
Vue.use(ElementUI);

const store = new Vuex.Store({
  state: {
    showSet: "dwgwsy"
  },

  // 获取
  getters: {
    getshowSet: state => {
      return state.showSet
    }
  },

  //修改  同步
  mutations:{
    changeShowset(state,showdata){
      state.showSet = showdata
    }
  },

  //修改 异步 分发
  actions: {
    changeShowsetAction({ commit }, data) {
      commit("changeShowset",data)
    }
  }

})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js